import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { featureFlags } from '@/lib/env';
import { YearEndAdjustmentConfirmationSearchSchema } from './year-end-adjustment-confirmation/-zod-schema';
export const Route = createFileRoute('/_staff/labor-core/year-end-adjustment-confirmation')({
  beforeLoad: () => {
    // YEA は FE mock のため、ENABLE_YEAR_END_ADJUSTMENT_OPERATION_PACKAGE で表示を制御する。
    // 無効なセッションでは直接 URL アクセスを packages 一覧へ戻す。
    if (!featureFlags.check('ENABLE_YEAR_END_ADJUSTMENT_OPERATION_PACKAGE')) {
      throw redirect({
        to: '/labor-core'
      });
    }
  },
  validateSearch: zodValidator(YearEndAdjustmentConfirmationSearchSchema)
});